var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_setup.isLoading
    ? _c(
        "div",
        { staticClass: "nav-bar-layout-wrapper" },
        [
          _c(_setup.JhiNavbar, {
            attrs: { "mandant-id": _setup.mandantId, admin: _setup.isAdmin },
          }),
          _vm._v(" "),
          _c("router-view"),
          _vm._v(" "),
          _c(_setup.JhiFooter),
        ],
        1
      )
    : _c("div", [_vm._m(0)])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "d-flex justify-content-center align-items-center",
        staticStyle: { height: "100vh" },
      },
      [
        _c(
          "div",
          { staticClass: "spinner-border", attrs: { role: "status" } },
          [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }